import type { Feature } from '@luna/gatekeeper';

export const pinDelivery: Feature = {
    enabled: false,
    _description: 'Displays pin delivery card in the delivery settings section',
};
